// extracted by mini-css-extract-plugin
export var arrowWrapper = "fc_fW";